import { Field, useSitecoreContext } from "@sitecore-jss/sitecore-jss-nextjs";
import {} from "@sitecore-jss/sitecore-jss-nextjs";
import * as ContainerWrapper from "@repo/ui/container";
import * as Flex from "@repo/ui/flex";
import { ComponentProps } from "../../../types/component-props";
import Placeholder from "../../placeholder-component/placeholder";
import styles from "./container.module.css";

const Container = (props: ComponentProps): JSX.Element => {
  const placeholders = props.rendering?.placeholders || {};
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;
  const pageColour = sitecoreContext.route?.fields?.pageColour as Field<string>;

  if (!placeholders && !isEditing) {
    return <></>;
  }

  const sxaTags = sitecoreContext.route?.fields?.SxaTags as {
    name: string;
  }[];

  const isHubShowcase = sxaTags?.some((tag) => tag.name === "Hub Showcase");

  return (
    <ContainerWrapper.Root
      style={pageColour ? { backgroundColor: pageColour.value } : undefined}
      className={styles.container}
      size="medium"
    >
      {placeholders &&
        Object.entries(placeholders).map(([key]) => {
          return (
            <Flex.Container
              key={`${props.rendering.uid}-${key}`}
              className={isHubShowcase ? styles.topBottomMargin : undefined}
              column
              gap={isHubShowcase ? "3xl" : "xl"}
            >
              <Placeholder name={key} rendering={props.rendering} />
            </Flex.Container>
          );
        })}
    </ContainerWrapper.Root>
  );
};

export default Container;
